// Keep in sync with eln_analytics_event.py
import {ELN_ANALYTICS_ACTIONS} from 'constants/analytics-products/ElnAnalyticsConstants';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';

export const LEGACY_STRUCTURED_TABLE_CONFIG_TO_TEMPLATE_CREATION_EVENTS = {
  [StructuredTableKind.TRANSFER]: ELN_ANALYTICS_ACTIONS.CREATED_TRANSFER_TABLE_CONFIG_IN_NOTEBOOK_TEMPLATE,
  [StructuredTableKind.REGISTRATION]: ELN_ANALYTICS_ACTIONS.CREATED_REGISTRATION_TABLE_CONFIG,
  [StructuredTableKind.RESULTS]: ELN_ANALYTICS_ACTIONS.CREATED_DATA_TABLE_CONFIG_IN_NOTEBOOK_TEMPLATE,
};

export const LEGACY_STRUCTURED_TABLE_TO_ENTRY_CREATION_EVENTS = {
  [StructuredTableKind.TRANSFER]: ELN_ANALYTICS_ACTIONS.CREATED_TRANSFER_TABLE_IN_NOTEBOOK_ENTRY,
  [StructuredTableKind.REGISTRATION]: ELN_ANALYTICS_ACTIONS.CREATED_REGISTRATION_TABLE_IN_ENTRY,
  [StructuredTableKind.RESULTS]: ELN_ANALYTICS_ACTIONS.CREATED_DATA_TABLE_IN_NOTEBOOK_ENTRY,
};
